/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Signup_LinkInputs */

const es_co2_login_signup_link = /** @type {(inputs: Login_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una`)
};

/**

* @param {Login_Signup_LinkInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const login_signup_link = /** @type {((inputs?: Login_Signup_LinkInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Signup_LinkInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_login_signup_link(inputs)
});